/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';

@Component({
  standalone: false,
  selector: 'adn-custom-event-type-label',
  template: `{{ ('customEvent.type.' + type) | ogTranslate }}`
})
export class CustomEventTypeLabelComponent {
  @Input() type: string;
}
